import { Skeleton } from "@/components/ui/skeleton";
import { CHAT_MESSAGES_CONTAINER_CLASS } from "@/components/VibeChat/constants";
import { cn } from "@/lib/utils";

const shimmerClassName = "from-gray-100 via-gray-200 to-gray-100";
const userBubbleShimmerClassName = "from-blue-200 via-blue-300 to-blue-200";

interface VibeChatLoadingShimmerProps {
  className?: string;
}

const AssistantMessageShimmer = ({ lineWidths }: { lineWidths: string[] }) => (
  <div className="flex w-full max-w-[90%] flex-col gap-2 py-1">
    {lineWidths.map(width => (
      <Skeleton key={width} className={cn(shimmerClassName, "h-4 rounded-md")} style={{ width }} />
    ))}
  </div>
);

const UserMessageShimmer = ({ width }: { width: string }) => (
  <div className="flex w-full justify-end">
    <Skeleton
      className={cn(userBubbleShimmerClassName, "h-10 rounded-2xl rounded-br-md")}
      style={{ width, maxWidth: "90%" }}
    />
  </div>
);

const ThinkingShimmer = () => (
  <div className="my-0.5 flex items-center gap-2">
    <Skeleton className={cn(shimmerClassName, "m-0.5 size-2 rounded-full")} />
    <Skeleton className={cn(shimmerClassName, "h-3 w-28 rounded-md")} />
  </div>
);

const VibeChatLoadingShimmer = ({ className }: VibeChatLoadingShimmerProps) => (
  <div className={cn(CHAT_MESSAGES_CONTAINER_CLASS, className)}>
    <div className="mx-auto flex w-full max-w-2xl flex-col gap-3">
      <UserMessageShimmer width="min(72%, 18rem)" />
      <AssistantMessageShimmer lineWidths={["88%", "76%", "64%"]} />
      <UserMessageShimmer width="min(56%, 14rem)" />
      <AssistantMessageShimmer lineWidths={["100%", "92%", "48%"]} />
      <ThinkingShimmer />
    </div>
  </div>
);

export default VibeChatLoadingShimmer;
